import Loader from 'react-loader-spinner';

const LoadingIndicator = ({ height, width, color = "#FFFFFF" }) => {
    return (
        <div
            style={{
                width: '100%',
                height: '25px',
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <Loader type="ThreeDots" color={color} height={height} width={width} />
        </div>
    )
}

export default LoadingIndicator;